__turbopack_context__.v({
  "content": "Flurry-module__Xe2mcW__content",
  "inner": "Flurry-module__Xe2mcW__inner",
  "root": "Flurry-module__Xe2mcW__root",
  "silhouette": "Flurry-module__Xe2mcW__silhouette",
});
